module.exports = __webpack_public_path__ + "static/media/essayiconhover.8493e639.svg";